import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProviderUser, adaptProviderUserFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_USER } from '../../backend-paths';


export const providerUserDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_PROVIDER_USER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_PROVIDER_USER}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerUserDeleteSlice = createSlice({
	name: 'providerUserDeleteSlice',
	initialState,
	reducers: {
		clearProviderUserDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerUserDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerUserDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerUserDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderUserDeleteSelector = () => useAppSelector(state => state[providerUserDeleteSlice.name]);

export const { clearProviderUserDelete } = providerUserDeleteSlice.actions;
